// src/admin/pages/Restaurants/MenuDetails.js
import React, { useState } from "react";
import "./MenuDetails.css";
import EditMenuItemModal from "./EditMenuItemModal";
// Modale per aggiungere piatto (nuovo file)
import AddMenuItemModal from "./AddMenuItemModal";

export default function MenuDetails({ menu, onMenuUpdated, categories }) {
  const [editingItem, setEditingItem] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);

  const handleEditClick = (item) => {
    setEditingItem(item);
  };

  const handleCloseEdit = () => {
    setEditingItem(null);
  };

  const handleDeleteItem = async (item) => {
    if (!window.confirm(`Eliminare il piatto "${item.name}"?`)) return;
    try {
      const token = localStorage.getItem("access_token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/menu/${item.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Errore eliminazione piatto");
      }
      // Rimuoviamo localmente il piatto
      const updatedItems = menu.items.filter((mi) => mi.id !== item.id);
      const updatedMenu = { ...menu, items: updatedItems };
      onMenuUpdated(updatedMenu);
    } catch (err) {
      alert(err.message);
    }
  };

  // Raggruppa i piatti per categoria
  const groupedByCategory = menu.items.reduce((acc, item) => {
    const cat = item.category || "Senza Categoria";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(item);
    return acc;
  }, {});
  const categoryNames = Object.keys(groupedByCategory);

  return (
    <div className="menu-details-container">
      <h3 className="menu-details-title">{menu.name}</h3>

      {/* Bottone apre modale per aggiungere piatto */}
      <button
        className="toggle-add-form-btn"
        onClick={() => setShowAddModal(true)}
      >
        + Aggiungi Piatto
      </button>

      {categoryNames.length === 0 ? (
        <p className="no-items-text">Nessun piatto in questo menù.</p>
      ) : (
        categoryNames.map((catName) => {
          const items = groupedByCategory[catName];
          return (
            <div key={catName} className="category-block">
              <h4 className="category-title">{catName}</h4>
              {items.map((item) => (
                <div key={item.id} className="menu-item-card">
                  <div className="menu-item-header">
                    <strong>{item.name}</strong> - €{item.price.toFixed(2)}
                    {!item.active && (
                      <span className="inactive-label"> (Inattivo)</span>
                    )}
                  </div>
                  <div className="menu-item-actions">
                    <button
                      className="edit-btn"
                      onClick={() => handleEditClick(item)}
                    >
                      Modifica
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDeleteItem(item)}
                    >
                      Elimina
                    </button>
                  </div>
                  {item.recipe && item.recipe.length > 0 && (
                    <ul className="recipe-list">
                      {item.recipe.map((ri) => (
                        <li key={ri.id} className="recipe-item">
                          <span>- {ri.ingredient_name}</span>{" "}
                          <strong>
                            {ri.qty_required}
                            {ri.unit ? ` ${ri.unit}` : ""}
                          </strong>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          );
        })
      )}

      {/* Modale per modifica di un piatto esistente */}
      {editingItem && (
        <EditMenuItemModal
          item={editingItem}
          onClose={handleCloseEdit}
          onMenuUpdated={onMenuUpdated}
          menu={menu}
          categories={categories}
        />
      )}

      {/* Modale per aggiunta nuovo piatto */}
      {showAddModal && (
        <AddMenuItemModal
          menu={menu}
          onMenuUpdated={onMenuUpdated}
          categories={categories}
          onClose={() => setShowAddModal(false)}
        />
      )}
    </div>
  );
}
